module.exports = __webpack_public_path__ + "media/icons/youtube-red-4cd517a7.png";